import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { apiKeysQueryOptions } from "@/app/api-keys/api/get-api-keys";
import { ApiKeysListSkeleton } from "@/app/api-keys/components/api-keys-list-skeleton";
import { ApiKeysList } from "@/app/api-keys/list";
import { PROJECT } from "@/app/capabilities/permissions";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/api-keys"
)({
  component: () => (
    <Suspense fallback={<ApiKeysListSkeleton />}>
      <ApiKeysList />
    </Suspense>
  ),
  beforeLoad: (ctx) => requireProjectPermission(ctx, PROJECT.apiKeys.read),
  loader: ({ context: { queryClient }, params }) => {
    queryClient.prefetchQuery(
      apiKeysQueryOptions({
        organizationId: params.organizationId,
        projectId: params.projectId,
      })
    );
    return { crumb: "API Keys" };
  },
});
